import Vue from 'vue';
import Vuex from 'vuex';
import error from './modules/error';
import user from './modules/user';
import location from './modules/location';
import config from './modules/config';
import wallet from './modules/wallet';
import keepAlive from './modules/keepAlive';
import getters from './getters';
import authInfo from './modules/authInfo';

const modules = {};

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    error,
    user,
    location,
    config,
    wallet,
    keepAlive,
    authInfo,
    ...modules,
  },
  getters,
});

export default store;
